import { render, staticRenderFns } from "./ProfitAndLoss.vue?vue&type=template&id=1a9ba2f6"
import script from "./ProfitAndLoss.vue?vue&type=script&lang=ts"
export * from "./ProfitAndLoss.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports